module.exports = __webpack_public_path__ + "static/media/kirthika-international.a71d6f64.png";